import React from 'react';
// Agenda Sales Follow up
const TwentyStepWhatsappTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    registration_link,
    your_name,
    contact_details,
  } = values;

  return (
    <div>
      <p>
        <strong>Dear {client_name ? client_name : `[Client Name]`},</strong>
      </p>

      <p>
        We haven't heard back from you regarding our previous email, and we're
        wondering if we missed any of your replies. The agenda has been
        finalized, and this is your last chance to enroll for{' '}
        {conference_short_name
          ? conference_short_name
          : `[Conference Short Name]`}
      </p>

      <p>
        If you're still interested in participating, please register as soon as
        possible to secure your spot:{' '}
        {registration_link ? (
          <a href={registration_link} target="_blank" rel="noopener noreferrer">
            {registration_link}
          </a>
        ) : (
          `[Registration Link]`
        )}
      </p>

      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default TwentyStepWhatsappTemplate;
